import { DEFAULT_RESULT_SIZE } from 'lib/workperks/common/constants';
export var SearchSortType;
(function (SearchSortType) {
    SearchSortType["Distance"] = "distance";
    SearchSortType["Relevance"] = "relevance";
    SearchSortType["Alphabetical"] = "alpha";
    SearchSortType["Tier"] = "tier";
    SearchSortType["RecentlyUpdated"] = "date";
})(SearchSortType || (SearchSortType = {}));
export const sortMap = [
    {
        title: 'Relevance',
        value: SearchSortType.Relevance,
    },
    {
        title: 'Distance',
        value: SearchSortType.Distance,
    },
    {
        title: 'Alphabetical',
        value: SearchSortType.Alphabetical,
    },
    {
        title: 'Recently Updated',
        value: SearchSortType.RecentlyUpdated,
    },
];
export default class SearchService {
    constructor({ user, location, resultSize = DEFAULT_RESULT_SIZE, language = 'en', esSource = true }) {
        this.language = 'en';
        this.distanceUnit = 'km';
        this.sort = SearchSortType.Relevance;
        this.sortDirection = false;
        this.offset = 0;
        this.resultSize = DEFAULT_RESULT_SIZE;
        this.esSource = true;
        this.banner = false;
        this.subcategoryId = [];
        this.categoryId = [];
        this.distance = 50;
        this.showNew = false;
        this.showOnlineOnly = false;
        this.showExpiringSoon = false;
        this.giftCardOnly = false;
        this.keyword = null;
        this.label = null;
        this.visibleLocations = false;
        this.random = false;
        this.account = null;
        this.accountIds = [];
        this._lastTotalHits = 0;
        this.user = user;
        // this.site = SiteViewModel.fromSite(site!);
        this.setLocation(location);
        this.resultSize = resultSize;
        this.language = language;
        this.esSource = esSource;
    }
    hasMoreResults() {
        if (!this._lastTotalHits) {
            return false;
        }
        return this.offset + this.resultSize < this._lastTotalHits;
    }
    setOffset(offset) {
        this.offset = offset;
        return this;
    }
    next() {
        if (!this.hasMoreResults()) {
            return Promise.reject();
        }
        this.offset += this.resultSize;
        return this.search();
    }
    search(query) {
        if (query) {
            this.setQuery(query);
        }
        return Promise.resolve([]);
    }
    searchWithTemplate(_) {
        console.warn('Not implemented');
        return Promise.resolve([]);
    }
    setQuery(query) {
        this.query = query && query.length > 0 ? query.toLowerCase() : undefined;
        this.impressionDidChange();
        return this;
    }
    setSort(sort) {
        this.sort = sort;
        return this;
    }
    setParentCategory(categoryId) {
        this.categoryId = categoryId;
        return this;
    }
    setSubCategory(subcategoryId) {
        this.subcategoryId = subcategoryId;
        return this;
    }
    setLocation(location) {
        var _a;
        this.location = location;
        this.distance = this.distance || ((_a = this.location) === null || _a === void 0 ? void 0 : _a.range) || 50;
        return this;
    }
    setDistance(distance) {
        this.distance = +distance;
        return this;
    }
    setShowVisibleLocations(visible) {
        this.visibleLocations = visible;
        return this;
    }
    setShowNew(showNew) {
        this.showNew = showNew;
        return this;
    }
    setShowOnlineOnly(showOnlineOnly) {
        this.showOnlineOnly = showOnlineOnly;
        return this;
    }
    setShowExpiringSoon(expiringSoon) {
        this.showExpiringSoon = expiringSoon;
        return this;
    }
    setGiftCardOnly(giftCardOnly) {
        this.giftCardOnly = giftCardOnly;
        return this;
    }
    setIDs(ids) {
        this.ids = ids;
        return this;
    }
    setHideIDs(ids) {
        this.hideIds = ids;
        return this;
    }
    setTemplate(template) {
        this.template = template;
        this.impressionDidChange();
        return this;
    }
    setRedemptionType(redemptionType) {
        this.redemptionType = redemptionType;
        return this;
    }
    setBanner(banner) {
        this.banner = banner;
        return this;
    }
    setRandom(random) {
        this.random = random;
        return this;
    }
    setESSource(esSource) {
        this.esSource = esSource;
        return this;
    }
    setResultSize(resultSize) {
        this.resultSize = resultSize;
        return this;
    }
    setTier(tier) {
        this.tier = tier;
        return this;
    }
    setLanguage(language) {
        this.language = language;
        return this;
    }
    setAccount(account) {
        this.account = account;
        return this;
    }
    setKeyword(keyword) {
        this.keyword = keyword;
        return this;
    }
    setLabel(label) {
        this.label = label;
        return this;
    }
    setLastHitsTotal(total) {
        this._lastTotalHits = total;
    }
    /**
     *  Returns a descriptor object for search impression
     *  analytics. Needed for PerkMappers to inject those
     *  impressions
     */
    impressionDescriptor() {
        var _a;
        return {
            templateId: (_a = this.template) === null || _a === void 0 ? void 0 : _a.id,
            query: this.query,
        };
    }
    serialize() {
        return {
            user: this.user,
            location: this.location,
            offset: this.offset,
            lastTotalHits: this._lastTotalHits,
            template: this.template,
        };
    }
    /**
     * Invoked when an impression property changes. Currently
     * only resets the perkMapper object to update itself with a
     * new impressionDescriptor.
     */
    impressionDidChange() {
        this._perkMapper = undefined;
    }
    static unserialize(serializedInstance) {
        const instance = new this(serializedInstance);
        instance.setOffset(serializedInstance.offset);
        instance.setLastHitsTotal(serializedInstance.lastTotalHits);
        if (serializedInstance.template)
            instance.setTemplate(serializedInstance.template);
        return instance;
    }
    get perkMapper() {
        if (!this._perkMapper)
            this._perkMapper = this.createPerkMapper();
        return this._perkMapper;
    }
    createPerkMapper() {
        throw Error('createPerkMapper called on abstract SearchService.');
    }
}
